import { isMobile, isTablet, isAndroid, isSafari, isFirefox } from 'react-device-detect';
import theme from 'shared/assets/style/theme';
import defaultTheme from './defaultTheme';
import { isNotStandaloneMobilePWA, isStandalonePWA, pwaStyleAdapter } from '../utils/mobileSupported';
import { height as NavHeight } from 'shared/components/NavigationBar/sizes';

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

const SgaTheme = {
  ...defaultTheme,
  LimitedTimeOffer: {
    ...defaultTheme.LimitedTimeOffer,
    BannerContainer: {
      ...defaultTheme.LimitedTimeOffer.BannerContainer,
      marginBottom: isMobile && !isTablet ? (isAndroid ? '1.5%' : '1%') : '2%',
      marginLeft: '-1.5%',
    },
    BuyButton: {
      ...defaultTheme.LimitedTimeOffer.BuyButton,
      transform: 'translateX(1%)',
    },
  },
  MessageDetails: {
    ...defaultTheme.MessageDetails,
    MessageTitle: {
      ...defaultTheme.MessageDetails.MessageTitle,
      marginBottom: '0.5rem',
    },
  },
  Button: {
    ...defaultTheme.Button,
    ButtonText: {
      ...defaultTheme.Button.ButtonText,
      paddingBottom: isMobile && !isAndroid ? 'unset' : '3%',
    },
  },
  NavigationBar: {
    ...defaultTheme.NavigationBar,
    LoyaltyBarContainer: {
      ...defaultTheme.NavigationBar.LoyaltyBarContainer,
      marginLeft: '-0.1rem',
    },
    LoyaltyCurrencyWrapperStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyle,
      right: windowWidth < 1400 ? 'calc(50% - 185px)' : 'calc(50% - 200px)',
    },
    LevelLabel: {
      ...defaultTheme.NavigationBar.LevelLabel,
      paddingBottom: isSafari ? 0 : 3,
      ...(isSafari && { transform: `translateY(2px)` }),
    },
    TopBar: {
      ...defaultTheme.NavigationBar.TopBar,
      height: isMobile && !isTablet ? (isAndroid ? '4.6rem' : '4.7rem') : '5.25rem',
    },
    FullButton: {
      ...defaultTheme.NavigationBar.FullButton,
      top: '-0.25rem',
    },
    LoyaltyCurrencyIconStyleWithMissionsbar: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyIconStyleWithMissionsbar,
      marginLeft: windowWidth < 1300 ? 10 : windowWidth < 1400 ? 25 : '8px',
    },
  },
  VIPItem: {
    ...defaultTheme.VIPItem,
    VipPackageContainer: {
      ...defaultTheme.VIPItem.VipPackageContainer,
      background: `
      linear-gradient(45deg, #845400, #78012f) padding-box,
      linear-gradient(45deg, #ff9502, #c86300, #a95f77) border-box
    `,
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    },
    Divider: {
      ...defaultTheme.VIPItem.Divider,
      background: 'linear-gradient(to right, transparent, rgba(214, 128, 7, 0.64), transparent)',
    },
    LogoImage: {
      ...defaultTheme.VIPItem.LogoImage,
      width: windowWidth > 1500 ? 250 : 200,
    },
  },
  LobbyOverlay: {
    ...defaultTheme.LobbyOverlay,
    MainSceneContainer: {
      ...defaultTheme.LobbyOverlay.MainSceneContainer,
      paddingTop: isNotStandaloneMobilePWA ? (windowHeight < 650 ? '4.8rem' : '4.5rem') : NavHeight,
    },
  },
  OutOfCoin: {
    ...defaultTheme.OutOfCoin,
    QuickBuyOfferDetails: {
      ...defaultTheme.OutOfCoin.QuickBuyOfferDetails,
      bottom: '17.5%',
    },
  },
  Start: {
    ...defaultTheme.Start,
    BottomBarFooterText: {
      ...defaultTheme.Start.BottomBarFooterText,
      marginTop: 5,
      marginBottom: 0,
    },
    MiddleSectionWrapper: {
      ...defaultTheme.Start.MiddleSectionWrapper,
      paddingInlineStart: '0.5rem',
    },
    MiddleLayoutButtonContainer: {
      ...defaultTheme.Start.MiddleLayoutButtonContainer,
      marginTop: isMobile && !isTablet ? (isNotStandaloneMobilePWA ? '25vh' : '10vh') : '5rem',
    },
    MiddleLayoutButtonText: {
      ...defaultTheme.Start.MiddleLayoutButtonText,
      ...(isMobile && !isTablet && !isAndroid && { margin: '5px 0 0 0 !important' }),
    },
  },
  CoinItem: {
    ...defaultTheme.CoinItem,
    LoyaltyIconCapWithBadge: {
      ...defaultTheme.CoinItem.LoyaltyIconCapWithBadge,
      height: '97%',
    },
    LoyaltyIconGoldapWithBadge: {
      ...defaultTheme.CoinItem.LoyaltyIconGoldapWithBadge,
      height: '98%',
    },
  },
  ForgotPassword: {
    ...defaultTheme.ForgotPassword,
    ModalContainer: {
      ...defaultTheme.ForgotPassword.ModalContainer,
      height: isMobile ? '55vh' : '70vh',
      minHeight: '300px',
    },
  },
  DefaultTooltip: {
    ...defaultTheme.DefaultTooltip,
    Border: {
      ...defaultTheme.DefaultTooltip.Border,
      stopColor1: '#edcf68',
      stopColor2: '#edcf68',
    },
    Background: {
      ...defaultTheme.DefaultTooltip.Background,
      stopColor1: '#7d411e',
      stopColor2: '#791515',
    },
  },
  BottomBar: {
    ...defaultTheme.BottomBar,
    RewardCenterIcon: {
      ...defaultTheme.BottomBar.RewardCenterIcon,
      height: !isTablet && isMobile ? '5.5em' : '6em',
    },
    NotificationText: {
      ...defaultTheme.BottomBar.NotificationText,
      paddingTop: '15%',
    },
    NotificationEvents: {
      ...defaultTheme.BottomBar.NotificationEvents,
      paddingTop: '0.83rem',
    },
    NotificationWatchAndEarn: {
      ...defaultTheme.BottomBar.NotificationWatchAndEarn,
      left: !isMobile ? '2em' : isAndroid && isTablet ? '2.2vw' : '3.2vw',
    },
    NotificationMission: {
      ...defaultTheme.BottomBar.NotificationMission,
      left: !isMobile ? '1.7em' : isTablet ? '0.8em' : '2.2vw',
    },
    BarChestItem: {
      ...defaultTheme.BottomBar.BarChestItem,
      marginLeft: !isMobile || isTablet || isAndroid ? 0 : '3rem',
      marginRight: !isMobile ? 0 : '3.5rem',
    },
    VIPIcon: {
      ...defaultTheme.BottomBar.VIPIcon,
      marginLeft: isMobile ? 'unset' : -5,
      height: !isMobile ? '5em' : isAndroid ? (isTablet ? '10vh' : '14vh') : isMobile && !isTablet ? '12vh' : '5.5em',
      position: 'relative',
      left: !isMobile ? -5 : isAndroid ? 'unset' : -5,
      bottom: isAndroid ? (isTablet ? '0.6vh' : '1vh') : 'unset',
    },
    SlotsIcon: {
      ...defaultTheme.BottomBar.SlotsIcon,
      height: isTablet ? '5em' : '4.5em',
      position: 'relative',
      left: !isMobile || isTablet ? 'unset' : -5,
      bottom: !isMobile || isAndroid || isTablet ? 'unset' : '-0.9vh',
    },
    TimerWrapper: {
      ...defaultTheme.BottomBar.TimerWrapper,
      width: !isMobile ? '100%' : isAndroid ? '90%' : isTablet ? '100%' : '110%',
      height: isMobile ? '68%' : '100%',
      left: !isMobile ? -5 : isAndroid ? (isTablet ? '2vw' : '4vw') : isTablet ? '2vw' : 10,
    },
    ChestOpenBarIcon: {
      ...defaultTheme.BottomBar.ChestOpenBarIcon,
      height: !isMobile ? '5.8em' : isAndroid ? (isTablet ? '10vh' : '13vh') : isTablet ? '11vh' : '5em',
      marginBottom: !isMobile ? '-0.2rem' : isStandalonePWA && isTablet ? '0.8rem' : 0,
      marginLeft: !isMobile ? 'unset' : isAndroid ? (isTablet ? '4vw' : '7vw') : '3em',
    },
    ChestClosedBarIcon: {
      ...defaultTheme.BottomBar.ChestClosedBarIcon,
      height: !isMobile ? '5.8em' : isAndroid ? (isTablet ? '10vh' : '13vh') : isTablet ? '11vh' : '5em',
      marginBottom: !isMobile ? '-0.2rem' : isStandalonePWA && isTablet ? '0.8rem' : 0,
      marginLeft: !isMobile ? 'unset' : isAndroid ? (isTablet ? '4vw' : '7vw') : '3em',
    },
    TimerLabel: {
      ...defaultTheme.BottomBar.TimerLabel,
      position: !isMobile ? 'absolute' : 'relative',
      bottom: !isMobile ? '0.78rem' : 0,
      paddingLeft: !isMobile ? '19%' : isTablet ? (isAndroid ? '18%' : '15%') : isMobile ? '20%' : '19%',
      marginBottom: !isMobile
        ? 'unset'
        : isAndroid
          ? isTablet
            ? '-4vh'
            : '-6.2vh'
          : isTablet
            ? isStandalonePWA
              ? '-4.3vh'
              : '-4.5vh'
            : '-7.4vh',
    },
    TimerBackground: {
      ...defaultTheme.BottomBar.TimerBackground,
      bottom: !isMobile ? '-0.6em' : isAndroid ? (isTablet ? '-1vh' : '-2vh') : isTablet ? '-1.4vh' : '-2.5vh',
    },
  },
  RewardCenter: {
    ...defaultTheme.RewardCenter,
    CardContainerMobile: {
      ...defaultTheme.RewardCenter.CardContainerMobile,
      ...(isAndroid && !isTablet && isMobile && { marginTop: isStandalonePWA ? '1.5vh !important' : '6.5vh !important' }),
    },
    PurchaseSuccess: {
      ...defaultTheme.RewardCenter.PurchaseSuccess,
      Button: {
        ...defaultTheme.RewardCenter.PurchaseSuccess.Button,
        paddingTop: isNotStandaloneMobilePWA
          ? '2.5rem'
          : isStandalonePWA
            ? isTablet && isAndroid
              ? '3rem'
              : '0.5rem'
            : 0,
      },
    },
  },
  RewardListItem: {
    ...defaultTheme.RewardListItem,
    OfferNameText: {
      ...defaultTheme.RewardListItem.OfferNameText,
      paddingTop: 4,
    },
    LoyaltyPointsText: {
      ...defaultTheme.RewardListItem.LoyaltyPointsText,
      paddingTop: 5,
    },
  },
  Tier: {
    ...defaultTheme.Tier,
    Card: {
      ...defaultTheme.Tier.Card,
      height: 60,
      width: 85,
      top: 'unset',
    },
    TierWrapper: {
      ...defaultTheme.Tier.TierWrapper,
      marginRight:
        windowWidth < 1300 ? '85px !important' : windowWidth < 1400 ? '105px !important' : '103px !important',
    },
    TierWrapperMissionInProgress: {
      marginRight: isTablet && windowWidth > 1150 ? '90px !important' : '100px !important',
      marginLeft: !isTablet ? 0 : windowWidth < 1150 ? '45px !important' : '10px !important',
    },
    CardAnimation: {
      ...defaultTheme.Tier.CardAnimation,
      left: -30,
    },
  },
  DailySpin: {
    ...defaultTheme.DailySpin,
    WheelItems: {
      ...defaultTheme.DailySpin.WheelItems,
      fontSize: windowWidth < 1400 ? '1.8rem' : '2rem',
    },
    StreakDaysRowNumber: {
      ...defaultTheme.DailySpin.StreakDaysRowNumber,
      paddingRight: 1,
      paddingTop: 4,
      paddingBottom: 2,
    },
    StreakDaysRowBigNumber: {
      ...defaultTheme.DailySpin.StreakDaysRowBigNumber,
      paddingRight: 1,
      paddingTop: 4,
      paddingBottom: 2,
    },
    StreakDaysRowValues: {
      ...defaultTheme.DailySpin.StreakDaysRowValues,
      marginTop: 5,
      lineHeight: 0,
    },
    MilestoneCoinsValue: {
      ...defaultTheme.DailySpin.MilestoneCoinsValue,
      marginBottom: isAndroid ? 13 : 0,
    },
    mileStoneRowCoinIcon: {
      ...defaultTheme.DailySpin.mileStoneRowCoinIcon,
      marginBottom: isMobile ? '0.3rem' : 0,
    },
    mileStoneRowCoinIconInCenter: {
      ...defaultTheme.DailySpin.MilestoneCoinsValue,
      top: 3,
    },
    MilestoneCircleValue: {
      ...defaultTheme.DailySpin.MilestoneCircleValue,
      marginLeft: 0,
      marginTop: windowWidth < 1300 ? '1%' : windowWidth < 1500 ? '2.5%' : '1%',
    },
    MileStoneRowLoyaltyIcon: {
      ...defaultTheme.DailySpin.MileStoneRowLoyaltyIcon,
      marginBottom: '1rem',
    },
    BottomRightCoinImage: {
      ...defaultTheme.DailySpin.BottomRightCoinImage,
      marginBottom: 5,
    },
    DailyWheelCollectButton: {
      ...defaultTheme.DailySpin.DailyWheelCollectButton,
      paddingBottom: 0,
    },
    BottomBarBackgroundWrapperImage: {
      ...defaultTheme.DailySpin.BottomBarBackgroundWrapperImage,
      height: '105%',
    },
  },
  CreditCardDetails: {
    ...defaultTheme.CreditCardDetails,
    CheckBoxBackgroundImage: {
      ...defaultTheme.CreditCardDetails.CheckBoxBackgroundImage,
      width: '40%',
    },
    CvvTooltipArrowOver: {
      ...defaultTheme.CreditCardDetails.CvvTooltipArrowOver,
      bottom: -27,
    },
  },
  MissionsProgress: {
    ...defaultTheme.MissionsProgress,
    TextProgress: {
      ...defaultTheme.MissionsProgress.TextProgress,
      marginBottom: isSafari ? 0 : '2px',
      ...(isSafari && { transform: `translateY(${isMobile ? 2 : 3}px)` }),
      ...(isAndroid && isMobile && { marginLeft: '1rem' }),
    },
    MissionIcon: {
      ...defaultTheme.MissionsProgress.MissionIcon,
      top: isMobile ? '-1.4vh' : -8,
    },
    RankContainer: {
      ...defaultTheme.MissionsProgress.RankContainer,
      top: isMobile ? '-1.4vh' : -8,
    },
    RankContainerWithNoCard: {
      ...defaultTheme.MissionsProgress.RankContainerWithNoCard,
      top: isMobile ? '-1.4vh' : -8,
    },
    BarShineEffect: {
      ...defaultTheme.MissionsProgress.BarShineEffect,
      boxShadow: '0px 0px 8px 4px rgba(0, 200, 255, 0.65) inset',
      WebkitBoxShadow: '0px 0px 8px 4px rgba(0, 200, 255, 0.65) inset',
      MozBoxShadow: '0px 0px 8px 4px rgba(0, 200, 255, 0.65) inset',
    },
    BarLabel: {
      ...defaultTheme.MissionsProgress.BarLabel,
      letterSpacing: isMobile && !isAndroid ? 0.2 : -1,
      bottom: isSafari ? 0 : 1.5,
      left: isMobile && !isTablet && !isAndroid ? '0.7vw' : '0.5vw',
      transform: isFirefox && !isAndroid ? `translateY(6px)` : isSafari ? `translateY(3px)` : undefined,
      fontSize: isTablet ? 23 : 26,
    },
    SlashText: {
      ...defaultTheme.MissionsProgress.SlashText,
      top: '-0.05em',
    },
    ProgressBarRankText: {
      ...defaultTheme.MissionsProgress.ProgressBarRankText,
      fontWeight: 700,
      letterSpacing: 2,
      ...(isMobile && {
        left: '0.1vw',
        fontSize: '1.8vw',
        top: isAndroid ? 'unset' : '0.6vh',
      }),
      ...(isTablet && { left: isAndroid ? '0.6vw' : windowWidth < 1420 ? '0.7vw' : '0.8vw' }),
    },
  },
  BattleProgressTooltip: {
    ...defaultTheme.BattleProgressTooltip,
    Title: {
    ...defaultTheme.BattleProgressTooltip.Title,
      textShadow: '1px 1px 1px #410307',
    },
    LeaderboardHeader: {
    ...defaultTheme.BattleProgressTooltip.LeaderboardHeader,
      textShadow: '1px 1px 1px #410307',
    },
  },
  BattlesGoal: {
    ...defaultTheme.BattlesGoal,
    InfoText: {
    ...defaultTheme.BattlesGoal.InfoText,
      textShadow: '0px 2px 0px #410307',
    },
    Amount: {
    ...defaultTheme.BattlesGoal.Amount,
      textShadow: '0px 3px 0px #410307',
    },
  },
  BattlesBegin: {
    ...defaultTheme.BattlesGoal.BattlesBegin,
    ButtonTextStyle: {
      ...defaultTheme.BattlesGoal.ButtonTextStyle,
      paddingTop: isMobile && !isAndroid ? '1.8%' : 0,
      paddingBottom: isMobile && !isAndroid ? 0 : '1%',
    },
  },
  BattlesRankingTable: {
    ...defaultTheme.BattlesRankingTable,
    TableHeaderItem: {
    ...defaultTheme.BattlesRankingTable.TableHeaderItem,
      textShadow: '0px 3px 0px #741718',
    },
    LeaderboardPlayerText: {
    ...defaultTheme.BattlesRankingTable.LeaderboardPlayerText,
      left: isMobile ? (isNotStandaloneMobilePWA ? '2.5vw' : '3.7vw') : '3vw',
    },
  },
  BattlesReward: {
    ...defaultTheme.BattlesReward,
    InfoText: {
    ...defaultTheme.BattlesReward.InfoText,
      textShadow: '0px 3px 0px #410307',
    },
    InfoAmountContainer: {
    ...defaultTheme.BattlesReward.InfoAmountContainer,
      textShadow: '0px 3px 0px #410307',
    },
    Amount: {
    ...defaultTheme.BattlesReward.Amount,
      textShadow: '0px 3px 0px #410307',
    },
  },
  BattlesTabsScreen: {
    ...defaultTheme.BattlesTabsScreen,
    InfoText: {
    ...defaultTheme.BattlesTabsScreen.InfoText,
      textShadow: '0px 3px 0px #410307',
    },
  },
  MissionCard: {
    ...defaultTheme.MissionCard,
    TimeLeftIcon: {
    ...defaultTheme.MissionCard.TimeLeftIcon,
    ...(isNotStandaloneMobilePWA && { marginTop: isAndroid ? 1 : 4 }),
    },
    CoinImage: {
    ...defaultTheme.MissionCard.CoinImage,
      marginTop: isNotStandaloneMobilePWA ? (isAndroid ? 7 : 3) : isStandalonePWA && isAndroid ? 4 : 0,
    },
    TimeLeftText: {
    ...defaultTheme.MissionCard.TimeLeftText,
      top: isNotStandaloneMobilePWA && !isTablet ? (windowHeight < 320 ? '-0.2rem' : 0) : '0.8rem'
    },
  },
  EntriesCounter: {
    ...defaultTheme.EntriesCounter,
    AmountText: {
      ...defaultTheme.EntriesCounter.AmountText,
      bottom: 1,
    },
  },
  ShopScreen: {
    ...defaultTheme.ShopScreen,
    ShopContainer: {
      ...defaultTheme.ShopScreen.ShopContainer,
      PackagesContainer: {
        ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer,
        padding: '6% 5.5rem 0.4rem',
        VIPItemContainer: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.VIPItemContainer,
          ...(!isMobile && { marginLeft: -7 }),
        },
      },
    },
  },
  Events: {
    ...defaultTheme.Events,
    TimeLeftText: {
      ...defaultTheme.Events.TimeLeftText,
      marginTop: '0.4rem',
    },
  },
  BonusLinkMessage: {
    ...defaultTheme.BonusLinkMessage,
    LPBonusContainer: {
      ...defaultTheme.BonusLinkMessage.LPBonusContainer,
      paddingTop: '355px',
    },
    CoinsBonusContainer: {
      ...defaultTheme.BonusLinkMessage.CoinsBonusContainer,
      paddingTop: isMobile && !isTablet ? (isAndroid ? '385px' : '407px') : '52.2%',
    },
    BonusButtonContainer: {
      ...defaultTheme.BonusLinkMessage.BonusButtonContainer,
      marginTop: '10px',
    },
    LoyaltyIcon: {
      ...defaultTheme.BonusLinkMessage.LoyaltyIcon,
      marginRight: '10px',
      marginTop: '1px',
    },
    CoinIcon: {
      ...defaultTheme.BonusLinkMessage.CoinIcon,
      marginTop: isMobile && !isAndroid ? '-3px' : '2px',
    },
  },
  SideBar: {
    ...defaultTheme.SideBar,
    MenuContainer: {
      ...defaultTheme.SideBar.MenuContainer,
      border: '5px solid #bf3857',
      background: 'linear-gradient(to bottom, #551621 0%, #6A1B29 25%, #902639 50%, #6A1B29 75%, #551621 100%)',
      ...(isMobile && { marginTop: isAndroid && isNotStandaloneMobilePWA ? '0.5vh !important' : '0vh !important' })
    },
    ItemButton: {
      ...defaultTheme.SideBar.ItemButton,
      ...(isStandalonePWA && { width: isAndroid ? '29vw' : '31.5vw' })
    },
  },
  VipAccessFlow: {
    ...defaultTheme.VipAccessFlow,
    DefaultVipHeaderTitle: {
      ...defaultTheme.VipAccessFlow.DefaultVipHeaderTitle,
      fontSize: isTablet ? '2.5vw' : isMobile ? '2.2vw' : window.innerWidth < 991 ? '1.8rem' : '2.5rem',
    },
    VipAccessButtonText: {
      ...defaultTheme.VipAccessFlow.VipAccessButtonText,
      paddingTop: isMobile && !isAndroid ? '0.5vh' : 'unset',
    },
    VipAccessRedeemButtonText: {
      ...defaultTheme.VipAccessFlow.VipAccessRedeemButtonText,
      paddingTop: isMobile && !isAndroid ? '0.5vh' : 'unset',
    },
  },
  OfferDetail: {
    ...defaultTheme.OfferDetail,
    CarouselIndicator: {
      ...defaultTheme.OfferDetail.CarouselIndicator,
      backgroundColor: theme.palette.common[3],
      border: 0,
    },
    CarouselIndicatorActive: {
      ...defaultTheme.OfferDetail.CarouselIndicatorActive,
      background: `linear-gradient(
        to bottom, 
        ${theme.palette.primary[24]} 0%,  
        ${theme.palette.primary[15]} 35%, 
        ${theme.palette.primary[15]} 65%, 
        ${theme.palette.primary[24]} 100%
      )`,
      border: 0,
    },
  },
  Bar: {
    ...defaultTheme.Bar,
    BarContainer: {
      ...defaultTheme.Bar.BarContainer,
      background: 'linear-gradient(180deg, #2A150F 0%, #6F3828 100%)',
    },
    BarProgress: {
      ...defaultTheme.Bar.BarProgress,
      background:
        'linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .25) 70%,  rgba(255, 255, 255, .4) 100%), linear-gradient(to bottom, rgba(223, 74, 222, 1) 50%, rgba(211, 56, 208, 1) 50%)',
    },
  },
  TimeRemaining: {
    ...defaultTheme.TimeRemaining,
    TimerLabel: {
      ...defaultTheme.TimeRemaining.TimerLabel,
      top: '-0.5rem',
    },
    VIPTimer: {
      ...defaultTheme.TimeRemaining.VIPTimer,
      top: pwaStyleAdapter(5, 'rem'),
    },
  },
  CurrencyDisplay: {
    ...defaultTheme.CurrencyDisplay,
    CoinsLabel: {
      ...defaultTheme.CurrencyDisplay.CoinsLabel,
      paddingBottom: isSafari ? 0 : 3,
      ...(isSafari && { transform: `translateY(2px)` }),
    },
    LoyaltyLabel: {
      ...defaultTheme.CurrencyDisplay.LoyaltyLabel,
      paddingBottom: isSafari ? 0 : 3,
      paddingLeft: windowWidth < 1300 ? 30 : 15,
      ...(isSafari && { transform: `translateY(2px)` }),
    },
  },
  OfferDetailDescription: {
    ...defaultTheme.OfferDetailDescription,
    ButtonText: {
      ...defaultTheme.OfferDetailDescription.ButtonText,
      paddingBottom: '3.3%',
    },
  },
  LinkAccountForm: {
    ...defaultTheme.LinkAccountForm,
    HeaderTitle: {
      ...defaultTheme.LinkAccountForm.HeaderTitle,
      marginTop: '0.3rem',
      fontSize: isTablet ? (isAndroid ? '1.6vw' : '2vw') : isMobile ? '1.75vw' : '1.8rem',
    },
    NeedHelpText: {
      ...defaultTheme.LinkAccountForm.NeedHelpText,
      top: '1.4rem',
    },
    Divider: {
      width: '100%',
      marginTop: '2rem',
    },
  },
  PiggyBankAmount: {
    ...defaultTheme.PiggyBankAmount,
    CoinsWrapper: {
      ...defaultTheme.PiggyBankAmount.CoinsWrapper,
      top: isTablet && !isAndroid ? '7.6dvw' : isNotStandaloneMobilePWA ? (isAndroid ? '6dvw' : '6.7dvw') : isStandalonePWA && !isAndroid ? '8.3dvw' : '7.3dvw',
    },
    CoinIcon: {
      ...defaultTheme.PiggyBankAmount.CoinIcon,
      top: isMobile && !isAndroid ? -10 : 1,
    },
    LoyaltyIcon: {
      ...defaultTheme.PiggyBankAmount.LoyaltyIcon,
      top: isMobile && !isAndroid ? -7 : 1,
    },
  },
  BrowserScreen: {
    ...defaultTheme.BrowserScreen,
    DescriptionWrap: {
      ...defaultTheme.BrowserScreen.DescriptionWrap,
      marginTop: 0,
    },
    ButtonContainer: {
      ...defaultTheme.BrowserScreen.ButtonContainer,
      marginTop: '5vh',
    },
  },
};

export default SgaTheme;

